/** Session: set on successful login; removed when the wish dialog opens. */
export const ADMIN_LOGIN_CELEBRATION_PENDING_KEY =
  "shipclues_admin_login_celebration_pending";

/** Local: once dismissed for this Independence Day year, don't show again that year. */
export const ADMIN_LOGIN_CELEBRATION_SEEN_KEY =
  "shipclues_independence_day_seen";

export function independenceDaySeenKey(year = new Date().getFullYear()) {
  return `${ADMIN_LOGIN_CELEBRATION_SEEN_KEY}_${year}`;
}

/**
 * Active on India's Independence Day (15 August).
 * Soft window 13–15 Aug so teams can preview the wish before the day.
 */
export function isIndependenceDayWishActive(date = new Date()) {
  if (date.getMonth() !== 7) return false;
  const day = date.getDate();
  return day >= 13 && day <= 15;
}

export function markAdminLoginCelebrationPendingIfFirst() {
  try {
    if (!isIndependenceDayWishActive()) return;
    const yearKey = independenceDaySeenKey();
    if (localStorage.getItem(yearKey) === "1") return;
    if (sessionStorage.getItem(ADMIN_LOGIN_CELEBRATION_PENDING_KEY) === "1") {
      return;
    }
    sessionStorage.setItem(ADMIN_LOGIN_CELEBRATION_PENDING_KEY, "1");
  } catch (_) {
    /* storage blocked */
  }
}

export function consumeAdminLoginCelebrationPending() {
  try {
    if (sessionStorage.getItem(ADMIN_LOGIN_CELEBRATION_PENDING_KEY) !== "1") {
      return false;
    }
    sessionStorage.removeItem(ADMIN_LOGIN_CELEBRATION_PENDING_KEY);
    return true;
  } catch {
    return false;
  }
}

export function markAdminLoginCelebrationSeen() {
  try {
    localStorage.setItem(independenceDaySeenKey(), "1");
  } catch (_) {
    /* ignore */
  }
}
